export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 0',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 0',
  },
  name: {
    fontWeight: 'bold',
    fontSize: '12px',
    '&+*': {
      marginLeft: '4px',
    },
  },
  value: {
    fontSize: '12px',
  },
}
